import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import Button from "../../components/common/button";
import * as actions from "./actions";
import { routePrefix } from "../../config";
import "./styles.css";
import { opdbGTM } from "../../utils/pulseUtils";
import { dateCalculation, dealSelected, fetchMerchantId, hightLightText } from "../../utils";
import Autocomplete from "../../components/common/autoComplete";
import Competitor from "./Competior/Competitor";
import TopPerforming from "./TopPerformingDeals/TopPerforming";
import DealsSummary from "./DealsSummary/DealsSummary";
import ChartExample from "./LineChart/LineChart";
import OngoingDeals from "./OngoingDeals/OngoingDeals";

const actionButtonStyle = { width: 80, height: 30, padding: 0, marginLeft: 5 };

class DealsList extends React.Component {
  state = {
    activeTab: "active",
    dealObj: {},
    merchantId: "",
    ongoingDealSelected: false,
    performanceTabSelected: true,
    competitorDataSelected: false,
    source: "",
    destination: "",
    selectedDuration: "weekly",
    selectedFilter: "ALL",
  };

  componentDidMount() {
    const merchantId = fetchMerchantId() || localStorage.getItem("merchant-id");
    this.setState({ merchantId });
    this.date = moment().format("YYYY-MM-DD");
    document.title = "Operator Deals";
    this.props.getOperatorDealsList(merchantId);
    this.props.fetchDealList();
    const today = new Date();
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    const data = {
      from_time: this.formattedDate(oneWeekAgo),
      to_time: this.formattedDate(today),
    };
    this.props.fetchDateWiseAggregrate(data);
    const date = dateCalculation(this.state.selectedDuration);
    const { startDate, endDate } = date;
    const dealData = {
      from_time: startDate,
      to_time: endDate,
      deal_type: this.state.selectedFilter,
    };
    this.props.fetchDealSummary(dealData);
    this.props.fetchDealsWiseAggregateData(dealData);

    const isEditDealOngoingPage = localStorage.getItem('EDIT_DEAL_ONGOING_DEAL');
    if(isEditDealOngoingPage === "true") {
      this.handleOngoingDeals();
      localStorage.setItem('EDIT_DEAL_ONGOING_DEAL', false);
    }
    const tabToOpen = localStorage.getItem('tab_selected');
    if(tabToOpen && tabToOpen==='ongoing'){
      this.handleOngoingDeals();
      localStorage.removeItem('tab_selected');
    }
    dealSelected.set(false, '', '');
  }
  formattedDate = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd} 00:00:00`;
  };

  onTabChange = (e) => {
    this.setState({
      activeTab: e.target.id,
    });
  };

  handleDurationChange = (event) => {
    this.setState({ selectedDuration: event.target.value });
    const date = dateCalculation(event.target.value);
    const { startDate, endDate } = date;
    const dealData = {
      from_time: startDate,
      to_time: endDate,
      deal_type: this.state.selectedFilter,
    };
    this.props.fetchDealSummary(dealData);
    this.props.fetchDealsWiseAggregateData(dealData);
    const data = {
        "from_time": startDate,
        "to_time": endDate
      }
    this.props.fetchTopRoutes(data);
    this.props.fetchDateWiseAggregrate(data);
  };

  handleFilterChange = (event) => {
    this.setState({ selectedFilter: event.target.value });
    const date = dateCalculation(this.state.selectedDuration);
    const { startDate, endDate } = date;
    const dealData = {
      from_time: startDate,
      to_time: endDate,
      deal_type: event.target.value,
    };
    this.props.fetchDealSummary(dealData);
    this.props.fetchDealsWiseAggregateData(dealData);
    const data = {
      "from_time": startDate,
      "to_time": endDate
    }
    this.props.fetchTopRoutes(data);
    const today = new Date();
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(today.getDate() - 7);
    const data1 = {
      from_time: this.formattedDate(oneWeekAgo),
      to_time: this.formattedDate(today),
    };
    this.props.fetchDateWiseAggregrate(data1);
  };

  onViewDealsClick = () => {};

  onEditDealsClick = (dealId) => {
    this.props.history.push(routePrefix + "/deals/edit/" + dealId);
    localStorage.setItem('EDIT_DEAL_ONGOING_DEAL', true);
  };

  onSourceItemSelect = (data) => {
    this.setState({ source: data });
  };

  onDestinationItemSelect = (data) => {
    this.setState({ destination: data });
  };

  onDisableDealsClick = (deal) => {
    this.props.updateDealStatus(
      {
        provider_id: deal.provider_id,
        operator_id: deal.operator_id,
        deal_type: deal.deal_type,
        deal_id: deal.deal_id,
        is_active: !deal.is_active,
      },
      this.state.merchantId,
      () => this.props.getOperatorDealsList(this.state.merchantId)
    );
  };

  onRefreshDealClick = (el) => {
    this.props.refreshDeal(
      {
        route_ids: [el.route_id],
        start_date: el.start_date,
        end_date: el.end_date,
      },
      this.state.merchantId
    );
  };

  onDeleteDealsClick = () => {};

  handleOngoingDeals = () => {
    this.setState({ ongoingDealSelected: true });
    this.setState({ performanceTabSelected: false });
    this.setState({ competitorDataSelected: false });
    opdbGTM.ongoingDealsTabClicked('od_deals_ongoing_deals_tab_clicked');
  };

  handlePerformanceTab = () => {
    const {dateWiseAggregateData, dealsWiseAggregateData} = this.props;
    this.setState({ performanceTabSelected: true });
    this.setState({ competitorDataSelected: false });
    this.setState({ ongoingDealSelected: false });
    const isGraphsShown = dateWiseAggregateData &&
                dateWiseAggregateData.date_wise_aggregation &&
                dateWiseAggregateData.date_wise_aggregation.length > 0;
    const activeDealTypes = dealsWiseAggregateData && dealsWiseAggregateData.deals_aggregated && dealsWiseAggregateData.deals_aggregated.length
    opdbGTM.performanceTabClicked('od_deals_performance_tab_clicked', activeDealTypes, isGraphsShown);
  };

  handleCompetitorTab = () => {
    this.props.clearBenchMarkingData();
    this.setState({ competitorDataSelected: true });
    this.setState({ performanceTabSelected: false });
    this.setState({ ongoingDealSelected: false });
    opdbGTM.competitorDealsTabClicked('od_deals_competitor_benchmarking_tab_clicked');
  };

  submitHandle = () => {
    const mockDetails = {
      paytm_src_id: this.state.source.city_id || "",
      paytm_dest_id: this.state.destination.city_id || "",
      src: this.state.source.name || "",
      dest: this.state.destination.name || "",
    };
    this.props.getBenchMarkingData(mockDetails); 
  };
  renderElements = function (item, value) {
    return (
      <div className="cursor">
        <p className="cityStyle">
          {value
            ? hightLightText(item.city_name || item.display_name, value)
            : item.city_name}
          {item.is_multi_district && item.district ? ` (${item.district})` : ""}
        </p>
        <p className="stateStyle">{item.state || ""}</p>
      </div>
    );
  };
  // searchCities = (e, fieldType) => {
  //   this.props.fetchCities(e.target.value, fieldType);
  // }

  getDealNameColor = function (dealType, isLabel) {
    const dealTypes = {
      LAST_MINUTE: { label: "Last Minute Deal", color: "#FED533" },
      EARLY_BIRD: { label: "Early Bird Deal", color: "#27AE5F" },
      SEAT_LEVEL: { label: "Seat Level Deal", color: "#58CCDE" },
      NEW_USER: { label: "New User Deal", color: "#964B00" },
      CUSTOM: { label: "Custom Deal", color: "#FFC0CB" },
      FLAT_DEAL: { label: "Custom Deal", color: "#FFC0CB" },
      RETURN_TRIP: { label: "Return Trip Deal", color: "#FFC0CB" },
    };
    if (isLabel) {
      return dealTypes[dealType] && dealTypes[dealType].label ? dealTypes[dealType].label : '';
    } else {
      return dealTypes[dealType] && dealTypes[dealType].color ? dealTypes[dealType].color : '';
    }
  };

  formatAssetStrings() {
    const { dateWiseAggregateData } = this.props;
    const dealTypeToColor = {
      'EARLY_BIRD': '#27AE5F',
      'LAST_MINUTE': '#FED533',
      'SEAT_LEVEL': '#58CCDE',
      'FLAT_DEAL': '#B3325D',
      'NEW_USER': '#EB5757',
    };
  
    const dataLength = dateWiseAggregateData && dateWiseAggregateData.date_wise_aggregation.length;
    const mappedColors = Array.from({ length: dataLength }, (_, index) =>
      dealTypeToColor[dateWiseAggregateData.date_wise_aggregation[index].deal_type] || '#CCCCCC'
    );
  
    return mappedColors;
  }

  render() {
    const {
      activeTab,
      competitorDataSelected,
      performanceTabSelected,
      ongoingDealSelected,
    } = this.state;
    const { dateWiseAggregateData, dealsWiseAggregateData } = this.props;
    const dealFilteredData = this.props.dealsList.filter((el) =>
      activeTab === "active" ? el.is_active : !el.is_active
    );
    const durationChart = (input) => {
      if(input === 'weekly') {
        return `1 week data`;
      } else if(input === '2days') {
        return `2 days data`;
      } else if(input === '30days') {
        return `30 days data`;
      } else if(input === 'today') {
        return `Today's data`;
      }
    }
    return (
      <div className="dealList">
        <div className="payout">
          <div className="deals-header">
            {false && <p className="payout-header-text">Deals</p>}
            {false && <p className="payout-updated-date">{this.date}</p>}
            <div className="pageHeader" style={{ marginTop: 12 }}>
              {false && (
                <div style={{ width: "80%", display: "flex" }}>
                  <div className="deals-tabs-wrp">
                    <div
                      id="active"
                      onClick={this.onTabChange}
                      className={`deal-tab ${
                        activeTab === "active" ? "deal-active-tab" : ""
                      }`}
                    >
                      Active
                    </div>
                    <div
                      id="disabled"
                      onClick={this.onTabChange}
                      className={`deal-tab ${
                        activeTab === "disabled" ? "deal-active-tab" : ""
                      }`}
                    >
                      Disabled
                    </div>
                  </div>
                </div>
              )}
              <div className="buttonsContainer">
                <Link to={routePrefix + "/deals/auditlog"}>
                  <div className="audit">
                    <span className="auditText">Activity Tracker</span>
                  </div>
                </Link>
                <div className="create-deal-button">
                  <Link to={routePrefix + "/deals/create"}>
                    <Button
                      styleObj={{ width: 200 }}
                      label="Create a New Deal"
                      onButtonClick={() => {
                        opdbGTM.createDealClicked();
                        localStorage.setItem('EDIT_DEAL_ONGOING_DEAL', false);
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="tabHeader">
            <div
              className={`performanceTab tab ${
                performanceTabSelected ? "tabSelectedBorder" : ""
              }`}
              onClick={() => this.handlePerformanceTab()}
            >
             <div className={`${
                performanceTabSelected ? "selectedTab" : ""
              }`}>Performance</div> 
            </div>
            <div
              className={`otherTab tab ${
                ongoingDealSelected ? "tabSelectedBorder" : ""
              }`}
              onClick={() => this.handleOngoingDeals()}
            >
              <div className={`${
                ongoingDealSelected ? "selectedTab" : ""
              }`}>
              Ongoing deals
              </div>          
            </div>
            <div
              className={`otherTab tab ${
                competitorDataSelected ? "tabSelectedBorder" : ""
              }`}
              onClick={() => this.handleCompetitorTab()}
            >
              <div className={`${
                competitorDataSelected ? "selectedTab" : ""
              }`}>
              Competitor data
              </div>            
            </div>
          </div>

          {false && (
            <div className="payout-content">
              <table className="payout-table">
                <thead>
                  <tr className="payout-table-header">
                    <th>Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Route</th>
                    <th>
                      Tickets Booked <br />{" "}
                      <span className="font12"> (using deals) </span>
                    </th>
                    <th>Discount</th>
                    {/*<th>Price Range</th>*/}
                    {/*<th>Status</th>*/}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!dealFilteredData.length && this.props.dealsListLoading && (
                    <tr>
                      <td colSpan={7} className="table-no-data">
                        Please wait, Loading Deals...
                      </td>
                    </tr>
                  )}
                  {!dealFilteredData.length && !this.props.dealsListLoading && (
                    <tr>
                      <td colSpan={7} className="table-no-data">
                        No Data Found
                      </td>
                    </tr>
                  )}
                  {dealFilteredData.map((el, i) => (
                    <tr key={el.deal_id} className="payout-table-row">
                      <td>{el.display_text}</td>
                      <td>{el.start_date}</td>
                      <td>{el.end_date}</td>
                      <td>
                        {el.service_ids[0] == "ALL"
                          ? "All Routes"
                          : `${el.src_city_name || ""} - ${
                              el.dest_city_name || ""
                            }`}
                      </td>
                      <td>{el.tickets_booked || 0}</td>
                      <td>{el.discount_value}</td>
                      <td>
                        <Button
                          styleObj={actionButtonStyle}
                          label="Edit"
                          onButtonClick={this.onEditDealsClick.bind(
                            this,
                            el.deal_id
                          )}
                        />
                        <Button
                          styleObj={actionButtonStyle}
                          label={el.is_active ? "Disable" : "Enable"}
                          onButtonClick={this.onDisableDealsClick.bind(
                            this,
                            el
                          )}
                        />
                        <Button
                          styleObj={actionButtonStyle}
                          label="Refresh"
                          onButtonClick={this.onRefreshDealClick.bind(this, el)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {performanceTabSelected && (
          <div className="filtersSection">
            <div className="durationBlock">
              <label htmlFor="durationSelect" className="typeLable">
                Deal Type
              </label>
              <select
                className="durationOption"
                id="durationSelect"
                value={this.state.selectedFilter}
                onChange={this.handleFilterChange}
              >
                <option value="ALL">ALL</option>
                <option value="EARLY_BIRD">Early Bird</option>
                <option value="LAST_MINUTE">Last Minute</option>
                <option value="NEW_USER">New User</option>
                <option value="SEAT_LEVEL">Seat Level</option>
                <option value="FLAT_DEAL">Custom</option>
              </select>
            </div>
            <div className="durationBlock">
              <label htmlFor="durationSelect" className="durationLable">
                Duration
              </label>
              <select
                className="durationOption"
                id="durationSelect"
                value={this.state.selectedDuration}
                onChange={this.handleDurationChange}
              >
                <option value="today">Today</option>
                <option value="2days">2 Days</option>
                <option value="weekly">Weekly</option>
                <option value="30days">30 Days</option>
              </select>
            </div>
          </div>
        )}

        {competitorDataSelected && (
          <div className="searchBox1">
            <div className="searchContainer">Search for route</div>
            <div className="inputBox1">
              <div className="searchBlock">
                  <Autocomplete
                    placeholder="Enter source"
                    onSelect={this.onSourceItemSelect}
                    defaultValue={this.props.source}
                    fieldName="source"
                    onChange={this.props.fetchCities}
                    renderElements={this.renderElements}
                    listData={this.props.sourceCityData}
                    type="text"
                    dealListPresent
                    ref={(source) => { this.source = source; }}
                    // className='searchInputBox'
                    compData
                  />
                  <Autocomplete
                    placeholder="Enter destination"
                    onSelect={this.onDestinationItemSelect}
                    defaultValue={this.props.destination}
                    fieldName="destination"
                    onChange={this.props.fetchCities}
                    renderElements={this.renderElements}
                    listData={this.props.destCityData}
                    type="text"
                    dealListPresent
                    ref={(destination) => { this.destination = destination; }}
                    // className='searchInputBox'
                    compData
                  />

                <button
                  className="submitCTA"
                  onClick={() => this.submitHandle()}
                >
                  Submit
                </button>
              </div>
              </div>
              <div className="competitorBorder"></div>
              <div className="inputBox1">
              <Competitor getBenchMarkData={this.props.getBenchMarkData} />
              </div>
          </div>
        )}
        {performanceTabSelected && (
          <div>
            <div className="dealText">Deals summary</div>
          {/* {dealsWiseAggregateData && dealsWiseAggregateData.deals_aggregated && Object.keys(dealsWiseAggregateData.deals_aggregated).length > 0 && <div className="dealText">Deals summary</div>} */}
            {
              <DealsSummary
                fetchDealSummary={this.props.fetchDealSummary}
                dealsSummaryData={this.props.dealsSummaryData}
                selectedDuration={this.state.selectedDuration}
                fetchDealsWiseAggregateData={this.props.fetchDealsWiseAggregateData}
                dealsWiseAggregateData={dealsWiseAggregateData && dealsWiseAggregateData.deals_aggregated}
                filter={this.state.selectedFilter}
              />
            }
            <div className="chartsMasterContainer">
              {dateWiseAggregateData &&
                dateWiseAggregateData.date_wise_aggregation &&
                dateWiseAggregateData.date_wise_aggregation.length > 0 &&
                dateWiseAggregateData.date_wise_aggregation.map((el, index) => (
                  <div className="chartContainer">
                    <div className="dealName">
                      <div>
                          {this.formatAssetStrings().map((color, index1) => (
                          index === index1 &&
                            <div
                              key={index}
                              className="colorBlock"
                              style={{
                                backgroundColor: color,
                              }}
                            ></div>
                          ))}
                      </div>
                      <span>
                        {this.getDealNameColor(el.deal_type, true)}
                        <span className="note">{durationChart(this.state.selectedDuration)}</span>
                      </span>
                    </div>
                    <ChartExample
                      key={index}
                      fetchDealsWiseAggregateData={this.props.fetchDealsWiseAggregateData}
                      dealsWiseAggregateData={this.props.dealsWiseAggregateData}
                      selectedDuration={this.state.selectedDuration}
                      fetchDateWiseAggregrate={
                        this.props.fetchDateWiseAggregrate
                      }
                      dateWiseData={el.date_wise}
                      strokeColor={this.getDealNameColor(el.deal_type, false)}
                    />
                  </div>
                ))}
            </div>

            <TopPerforming
              fetchTopRoutes={this.props.fetchTopRoutes}
              getTopRoutes={this.props.getTopRoutes}
              allroutesInfo={this.props.allRoutesInfo}
              selectedDuration={this.state.selectedDuration}
            />
          </div>
        )}
        {ongoingDealSelected && (
          <div>
            <OngoingDeals
              getDealData={this.props.getDealData}
              fetchDealSummary={this.props.fetchDealSummary}
              dealsSummaryData={this.props.dealsSummaryData}
              selectedDuration={this.state.selectedDuration}
              dealsData={this.props.dealsList}
              actionButtonStyle={actionButtonStyle}
              onEditDealsClick={this.onEditDealsClick}
              onRefreshDealClick={this.onRefreshDealClick}
              onDisableDealsClick={this.onDisableDealsClick}
              dealsListLoading={this.props.dealsListLoading}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  dealsList: store.dealsReducer.dealsList,
  dealsListLoading: store.dealsReducer.dealsListLoading,
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
  auditDealData: store.dealsReducer.auditDealData,
  sourceCityData: store.dealsReducer.sourceCityData,
  destCityData: store.dealsReducer.destCityData,
  getBenchMarkData: store.dealsReducer.getBenchMarkData,
  getTopRoutes: store.dealsReducer.getTopRoutes,
  dealsWiseAggregateData: store.dealsReducer.dealsWiseAggregateData,
  dealsSummaryData: store.dealsReducer.dealsSummaryData,
  getDealData: store.dealsReducer.getDealData,
  dateWiseAggregateData: store.dealsReducer.dateWiseAggregateData,
});

const mapDispatchToProps = (dispatch) => ({
  getOperatorDealsList: (merchantId) =>
    dispatch(actions.getOperatorDealsList(merchantId)),
  updateDealStatus: (data, query, callback) =>
    dispatch(actions.updateDealStatus(data, query, callback)),
  refreshDeal: (payload, query) =>
    dispatch(actions.refreshDeal(payload, query)),
  fetchCities: (queryStr, fieldType) =>
    dispatch(actions.fetchCities(queryStr, fieldType)),
  getBenchMarkingData: (mockDetails) =>
    dispatch(actions.getBenchMarkingData(mockDetails)),
  fetchTopRoutes: (mockDetails) =>
    dispatch(actions.fetchTopRoutes(mockDetails)),
  fetchDealsWiseAggregateData: (mockDetails) =>
    dispatch(actions.fetchDealsWiseAggregateData(mockDetails)),
  fetchDealSummary: (mockDetails) =>
    dispatch(actions.fetchDealSummary(mockDetails)),
  fetchDealList: () => dispatch(actions.fetchDealList()),
  fetchDateWiseAggregrate: (payload) =>
    dispatch(actions.fetchDateWiseAggregrate(payload)),
    clearBenchMarkingData: () => dispatch(actions.clearBenchMarkingData())
});

DealsList.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(DealsList);
